import styled from 'styled-components';
import ImageWrapper from '../ImageWrapper';
import { useSelector } from 'react-redux';

interface LogoProps {
  logoPath: string;
  handleClick?: () => void;
  loading?: 'eager' | 'lazy';
}
const NewLogo = ({ logoPath, loading, handleClick }: LogoProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  return (
    <LogoContainer
      className="logo-container first-layer"
      itemProp="logo"
      onClick={handleClick}
      style={{ cursor: handleClick ? 'pointer' : 'default' }}
    >
      <div className="second-layer">
        <div className="img-wrapper">
          <ImageWrapper
            src={logoPath}
            alt="logo"
            fill
            priority
            withSkeleton
            objectFit="cover"
            imageSize={isMobile ? 'low' : 'medium'}
            quality={50}
            sizes="50vw"
            loading={loading}
          />
        </div>
      </div>
    </LogoContainer>
  );
};

const LogoContainer = styled.div`
  min-width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(178, 178, 178, 0.2);

  .second-layer {
    width: calc(100% - 5px);
    height: calc(100% - 5px);
    background: rgba(194, 194, 194, 0.3);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .img-wrapper {
      width: calc(100% - 5px);
      height: calc(100% - 5px);
      overflow: hidden;
      border-radius: 50%;
      position: relative;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
    }
  }
`;
export default NewLogo;
